import { useEffect, useState, useRef } from 'react';
import ApplyNow from '../ApplyNow/ApplyNow';
import './CreatorCashSub.css';
import YouTube from '../../../assets/images/CreatorCash/youtube-btn.svg';
import { useCreatorCashContext } from '../../../context/CreatorCashProvider';
import FadeInSection from '../../FadeInComponent/FadeInComponent';
import { useLocation } from 'react-router-dom';
import { renderMessage } from '../../../utils/helper';
import Input from '../../Input/Input';
import Switch from '../../Switch/Switch';

/* global fbq */

const INPUT_SCHEMA = [
    { type: "url" },        // index 0
    { type: "number" },     // index 1
    { type: "number" },     // index 2
    { type: "boolean" },    // index 3 (switch)
    { type: "boolean" }     // index 4 (switch)
];

export default function CreatorCashSub({ scrollRef, scrollToRef }) {

    const { search } = useLocation();
    const queryValue = new URLSearchParams(search);

    const { state } = useCreatorCashContext();
    const creatorCashContent = state?.creatorCashSection;
    const variant = state?.variant;

    const [formValues, setFormValues] = useState({});
    const [eligiblePercentage, setEligiblePercentage] = useState(0);
    const containerRef = useRef(null);
    const [step, setStep] = useState(sessionStorage.getItem("oAuthState") ?? 1);

    useEffect(() => {
        const oAuthState = state.authState;
        if (oAuthState === "submitted") setStep(2);
        else if (oAuthState === "failed" && oAuthState !== "submitted") setStep(3);
        else if (oAuthState === "rejected" && oAuthState !== "submitted") setStep(4);
        else setStep(1);
    }, [state.authState]);

    useEffect(() => {
        if (step === 2 || step === 3 || step === 4) {
            setTimeout(() => {
                if (scrollRef.current) scrollToRef();
            }, 500);
        }
    }, [step, scrollToRef, scrollRef]);

    const handleInputChange = (index, value) => {
        const fieldType = INPUT_SCHEMA[index]?.type;

        let validatedValue = value;

        // --- Numeric fields (index 1 & 2) ---
        if (fieldType === "number") {
            if (value === "" || isNaN(value)) {
                validatedValue = "";
            } else {
                validatedValue = Number(value);
            }
        }

        // --- Boolean (switch) fields (index 3 & 4) ---
        if (fieldType === "boolean") {
            validatedValue = Boolean(value);
        }

        setFormValues(prev => ({
            ...prev,
            [index]: validatedValue
        }));
    };

    const getErrorSubTitle = () => {
        if ([queryValue.get("error"), queryValue.get("reject")].every((state) => state === "true")) {
            return "You don't meet the requirements."
        } else {
            return creatorCashContent?.failureMessage?.subTitle1
        }
    }

    const handleClickConnectYoutube = () => {
        if (window.gtag) {
            window.gtag('event', 'connect_youtube_click', {
                variant: variant?.toUpperCase(),
            });
        }

        if (step === 1) {
            fbq('track', 'AddToCart');
            window?.ttq?.track('AddToCart');
        }

    }

    // const validateYouTubeChannel = (value) => {
    //     const youtubeChannelRegex =
    //         /^(https?:\/\/)?([a-zA-Z0-9-]+\.)?youtube\.com\/(channel\/[A-Za-z0-9_-]+|c\/[A-Za-z0-9_-]+|user\/[A-Za-z0-9_-]+|@[A-Za-z0-9._-]+)(\/.*|\?.*)?$/;
    //     return youtubeChannelRegex.test(value);
    // };

    useEffect(() => {
        let count = 0;

        if (formValues[0]) count += 20;
        if (Number(formValues[1]) >= 1000) count += 20;
        if (Number(formValues[2]) >= 250) count += 20;
        if (formValues[3]) count += 20;
        if (formValues[4]) count += 20;

        setEligiblePercentage(count);
    }, [formValues]);

    useEffect(() => {
        const is20Crosses = sessionStorage.getItem("is20Crossed") ?? null;
        if (eligiblePercentage >= 20 && !is20Crosses) {
            sessionStorage.setItem("is20Crossed", true);
            if (window?.gtag)
                window.gtag('event', 'check_eligibility_start', {
                    variant: variant?.toUpperCase(),
                });
        }
    }, [eligiblePercentage, variant]);

    return (
        <div className='subs-container'>
            <div className='subscription-wrapper' ref={scrollRef}>
                <div className='hidden-part'></div>
                <div className='mobile-banner'></div>
                <div className='mob-banner absolute'></div>

                {step === 1 && (
                    <FadeInSection className="step1-container">
                        <div className='flex flex-col gap-[16px]'>
                            <div className="step1-title">{creatorCashContent?.step1?.title}</div>
                            <div className="step1-sub-title">{creatorCashContent?.step1?.subTitle}</div>
                        </div>
                        <div className="flex flex-col inputs-container">
                            <div className="form-inputs flex flex-col" ref={containerRef}>
                                {
                                    creatorCashContent?.step1?.userInputs?.map((collector, index) => {
                                        return collector?.isTypeSwitch ? (
                                            <Switch
                                                key={index}
                                                label={collector?.label}
                                                checked={!!formValues[index]}
                                                onChange={(e) => handleInputChange(index, e.target.checked)}
                                            />
                                        ) : (
                                            <Input
                                                key={index}
                                                name={`input${index}`}
                                                label={collector?.label}
                                                placeholder={collector?.placeholder}
                                                type={collector?.type}
                                                value={formValues[index] || ""}
                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                                prefix={"$"}
                                            />
                                        )
                                    })
                                }
                            </div>
                            <div className='form-actions flex flex-col'>
                                {
                                    eligiblePercentage === 100 ? (
                                        <FadeInSection className='if-100-percent'>{creatorCashContent?.step1?.subTitle1}</FadeInSection>
                                    ) : (
                                        <FadeInSection className='flex flex-col progress-container'>
                                            <div>{eligiblePercentage}% Eligible</div>
                                            <progress value={eligiblePercentage} max={100} />
                                        </FadeInSection>
                                    )
                                }
                                <a target='_top' href='https://ocncreatorcash.channelmeter.com/application/start/youtube?ref=&subnetwork=&d=ocncreatorcash.channelmeter.com&p=https%3A&lang=' onClick={handleClickConnectYoutube}>
                                    <ApplyNow
                                        icon={YouTube}
                                        className="connect-youtube"
                                        label={creatorCashContent?.step1?.action?.title}
                                        disabled={eligiblePercentage !== 100}
                                    />
                                </a>
                                <div className='text-center support'>
                                    {renderMessage(
                                        creatorCashContent?.step1?.support?.copy,
                                        `${creatorCashContent?.step1?.support?.mailTo}`
                                    )}
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                )}

                {step === 2 && (
                    <FadeInSection className="oauth-message">
                        <div className="oauth-title">{creatorCashContent?.successMessage?.title}</div>
                        <div className="oauth-info">
                            {creatorCashContent?.successMessage?.content?.map((con, index) => (
                                <div key={index}>
                                    {renderMessage(con, creatorCashContent?.successMessage?.mailTo)}
                                </div>
                            ))}
                        </div>
                    </FadeInSection>
                )}

                {step === 3 && (
                    <FadeInSection className="oauth-message">
                        <div className="oauth-title">{creatorCashContent?.failureMessage?.title}</div>
                        <div className="oauth-info">
                            <div dangerouslySetInnerHTML={{ __html: getErrorSubTitle() }}></div>
                            <a target='_top' href='https://ocncreatorcash.channelmeter.com/application/start/youtube?ref=&subnetwork=&d=ocncreatorcash.channelmeter.com&p=https%3A&lang=' onClick={handleClickConnectYoutube}>
                                <ApplyNow
                                    icon={YouTube}
                                    label="Connect YouTube"
                                    className="connect-youtube failure"
                                />
                            </a>
                            <div>
                                {renderMessage(
                                    creatorCashContent?.failureMessage?.subTitle2,
                                    creatorCashContent?.failureMessage?.mailTo
                                )}
                            </div>
                        </div>
                    </FadeInSection>
                )}

                {step === 4 && (
                    <FadeInSection className="step1-container rejection-screen">
                        <div className='flex flex-col gap-[16px]'>
                            <div className="step1-title reject-title">{creatorCashContent?.rejectionMessage?.title}</div>
                            <div className="step1-sub-title-rejection">
                                Based on your YouTube channel, you do not currently meet the requirements for Wealthworthy.
                                <br />
                                To qualify, your channel must:
                            </div>
                        </div>
                        <div className="flex flex-col inputs-container !min-h-[auto]">
                            <ol className=''>
                                {
                                    creatorCashContent?.rejectionMessage?.steps?.map((step) => {
                                        return (
                                            <div className='list-inside flex gap-[16px]'>
                                                <div className="ol-list">•</div>
                                                <div className="ol-list">{step}</div>
                                            </div>
                                        )
                                    })
                                }
                            </ol>
                            <div className='form-actions flex flex-col'>
                                <a target='_top' href='https://ocncreatorcash.channelmeter.com/application/start/youtube?ref=&subnetwork=&d=ocncreatorcash.channelmeter.com&p=https%3A&lang=' onClick={handleClickConnectYoutube}>
                                    <ApplyNow
                                        icon={YouTube}
                                        className="connect-youtube reject-action-button"
                                        label={
                                            <>
                                                <div className="block md:hidden">Connect YouTube</div>
                                                <div className="hidden md:block">{creatorCashContent?.rejectionMessage?.action}</div>
                                            </>
                                        }
                                    />
                                </a>
                            </div>
                            <div className='flex flex-col form-actions'>
                                <FadeInSection className='reject-support'>{creatorCashContent?.rejectionMessage?.message}</FadeInSection>
                                <div className='text-center support'>
                                    {renderMessage(
                                        creatorCashContent?.rejectionMessage?.subTitle2,
                                        creatorCashContent?.rejectionMessage?.mailTo
                                    )}
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                )}
            </div>
        </div>
    );
}
